import { Link } from 'react-router-dom';
import aboutImg from '../../assets/img/home3/At a Glance 476 x 621 .jpg';
// import img1 from '../../assets/img/home3/about-element.png';
import img2 from '../../assets/img/home3/idea.png';


const AboutThree = () => {

    return (
        <>
            <section className="about-our-agency section-padding fix">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-6 col-lg-6 pe-xl-5 ps-xl-5 col-12">
                            <div className="about-company-img">
                                <img src={aboutImg} alt="" />
                                {/* <img src={img1} className="about-element" alt="" /> */}
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-12 mt-5 mt-lg-0">
                            <div className="section-title-3">
                                {/* <h6>About Company</h6> */}
                                <h2>At a Glance </h2>
                                <p>Shree Gita Group is a leading merchandiser of commodities and processor of agricultural goods, with operations spanning the entire value chain. Our expertise lies in manufacturing, trading, marketing, importing, and exporting a wide range of agro commodities. </p>
                                <p>With over 100 years of industry experience, we leverage our deep-rooted knowledge to manage a diverse portfolio, including raw cotton, edible and non-edible oils, oil cakes, de-oiled cakes (meals), oilseeds, grains, rice, and pulses. </p> 
                                <p>Our diversified approach helps mitigate risks while ensuring our position as a key industry player. We are committed to driving progress, modernizing supply chains, and addressing the global challenge of sustainable food supply. </p>
                            </div>
                            {/* <div className="icon-features-item mt-40">
                                <div className="icon">
                                    <img src={img2} alt="" />
                                </div>
                                <div className="content">
                                    <h4>Creative Ideas</h4>
                                    <p>Up the duff bonnet daft amongst bog oxford <br /> creative ideas</p>
                                </div>
                            </div> */}
                            <Link to='/about' className="theme-btn style-3 mt-30">Discover Us</Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AboutThree;